export default {
  order_again: 'Zamów ponownie',
  error_messages: {
    product_does_not_exist: 'Produkt nie jest już dostępny',
  },
  success_messages: {
    product_added_to_card: 'Produkt dodany do koszyka',
  },
};
